import Cookies from 'universal-cookie';

// main cookie storage
const cookies = new Cookies();

export default cookies;
